// Save photos/videos straight into the phone gallery (native only, via
// @capacitor-community/media). Web: no-op (returns false).
import { Capacitor } from "@capacitor/core";

const PREF_KEY = "osc_save_gallery";
const ALBUM = "OnSiteComms";

export const galleryAvailable = () => Capacitor.isNativePlatform();
export const getSaveToGalleryPref = () => { try { return localStorage.getItem(PREF_KEY) === "1"; } catch (e) { return false; } };
export const setSaveToGalleryPref = (v) => { try { localStorage.setItem(PREF_KEY, v ? "1" : "0"); } catch (e) { /* ignore */ } };

let albumId; // Android needs an album identifier; iOS saves to Camera Roll (add-only permission)
async function ensureAlbum(Media) {
  if (Capacitor.getPlatform() !== "android") return undefined;
  if (albumId) return albumId;
  const find = async () => {
    const { albums } = await Media.getAlbums();
    const { path } = await Media.getAlbumsPath();
    return albums.find((a) => a.name === ALBUM && (a.identifier || "").startsWith(path))?.identifier;
  };
  albumId = await find();
  if (!albumId) { await Media.createAlbum({ name: ALBUM }); albumId = await find(); }
  return albumId;
}

/** items: [{ path: dataUrl | https URL, kind: "photo" | "video", fileName? }] → number saved */
export async function saveToGallery(items, job) {
  if (!galleryAvailable() || !items?.length) return 0;
  const { Media } = await import("@capacitor-community/media");
  const { mediaBaseName } = await import("./share");
  let albumIdentifier;
  try { albumIdentifier = await ensureAlbum(Media); } catch (e) { albumIdentifier = undefined; }
  let n = 0;
  for (const it of items) {
    try {
      const opts = { path: it.path, albumIdentifier, fileName: it.fileName || mediaBaseName(null, job) };
      if (it.kind === "video") await Media.saveVideo(opts); else await Media.savePhoto(opts);
      n += 1;
    } catch (e) { /* one failure must not block the rest */ }
  }
  return n;
}
